import { ReactElement } from 'react'
import { Spinner } from 'react-bootstrap'

export const AppLoader = (): ReactElement => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Spinner animation="border" />
    </div>
  )
}
